import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

const validateCourseUpload = async ({ clientId, collegeId, file }) => {
  const formData = new FormData();

  formData.append("file", file);

  const response = await axios.post(
    `${API_BASE_URL}/api/course-upload/${clientId}/${collegeId}/validate`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

const importCourseUpload = async ({ clientId, collegeId, rows }) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/course-upload/${clientId}/${collegeId}/import`,
    {
      rows,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export default {
  validateCourseUpload,
  importCourseUpload,
};
